import { minWidth } from './buildMediaQueries';

const sharedHeadlineStyles = `
  word-break: break-word;
  line-height: 1.2;
  margin: 0;
`;

/************ H1 ****************/
const h1FontSizes = {
  xs: '26px',
  sm: '30px'
};
export const h1Styles = `
  font-size: ${h1FontSizes.xs};
  ${sharedHeadlineStyles}
  ${minWidth('sm', `font-size: ${h1FontSizes.sm};`)}
`;

/************ H2 ****************/
const h2FontSizes = {
  xs: '20px',
  sm: '22px'
};
export const h2Styles = `
  font-size: ${h2FontSizes.xs};
  font-weight: 700;
  ${sharedHeadlineStyles}
  ${minWidth('sm', `font-size: ${h2FontSizes.sm};`)}
`;

/************ H3 ****************/
const h3FontSizes = {
  xs: '20px'
};
export const h3Styles = `
  font-size: ${h3FontSizes.xs};
  font-weight: 700;
  ${sharedHeadlineStyles}
`;

const headlines: { [key: string]: string } = {
  h1: h1Styles,
  h2: h2Styles,
  h3: h3Styles
};

const headlinesCss: string[] = Object.keys(headlines).map((h: string) => {
  return `${h}, .look-alike-${h} {${headlines[h]}}`;
});

export const buildHeadlinesCSS = () => headlinesCss.join('\n');
